import { render, staticRenderFns } from "./ExportStatistics.vue?vue&type=template&id=11487d66&scoped=true&"
import script from "./ExportStatistics.vue?vue&type=script&lang=ts&"
export * from "./ExportStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11487d66",
  null
  
)

export default component.exports